import { useCallback, useEffect, useRef, useState } from 'react';

// Surfaces HROAS failures as a dialog (once, when they first arrive) instead of a permanent banner,
// so it doesn't eat chart space every render. A dialog that opened itself closes itself when the
// failures clear (e.g. a transient no-data gap while loading) instead of lingering with only notes;
// one the user opened or closed stays under the user's control, and the pill reopens it on demand.
export const useHroasWarningDialog = (isHroas: boolean, failureCount: number) => {
  const [show, setShow] = useState<boolean>(false);
  // true while the dialog is open because failures appeared (not because the user opened it)
  const autoOpenedRef = useRef<boolean>(false);

  useEffect(() => {
    if (isHroas && failureCount > 0) {
      autoOpenedRef.current = true;
      setShow(true);
    } else if (autoOpenedRef.current) {
      autoOpenedRef.current = false;
      setShow(false);
    }
  }, [isHroas, failureCount]);

  const open = useCallback(() => {
    autoOpenedRef.current = false;
    setShow(true);
  }, []);
  const close = useCallback(() => {
    autoOpenedRef.current = false;
    setShow(false);
  }, []);

  return { show, open, close };
};
